import React from 'react';
import TenantManagementLayout from '../tenants/TenantManagementLayout';
import UserManagement from '../UserManagement';

/**
 * Platform User Management Page
 * Uses TenantManagementLayout for consistent admin navigation
 */
const UserManagementPage = () => {
  return (
    <TenantManagementLayout title="Platform Users" subtitle="Manage platform admin accounts and roles">
      <UserManagement />
    </TenantManagementLayout>
  );
};

export default UserManagementPage;
